var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"echarts",style:({ width: _vm.width, height: _vm.height }),on:{"mousewheel":function($event){$event.stopPropagation();}}})
}
var staticRenderFns = []

export { render, staticRenderFns }